import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DashboardComparerState, FilesSourceState, MappedScenario, RowsSourceState } from "./types";

const initialState: DashboardComparerState = {
    scenarios: [],
    masterScenario: null,
    detailScenario: null,
    selectedFile: null,
    showFilesSpinner: false,
    showRowsSpinner: false,
    showResultsSpinner: false,
    filesSource: null,
    rowsSource: null,
};

export const dashboardComparerSlice = createSlice({
    name: "comparerDshb",
    initialState,
    reducers: {
        setScenarios(state, action: PayloadAction<MappedScenario[]>) {
            state.scenarios = action.payload;
        },
        setMasterScenario(state, action: PayloadAction<number>) {
            state.masterScenario = action.payload;
        },
        setDetailScenario(state, action: PayloadAction<number>) {
            state.detailScenario = action.payload;
        },
        setFilesSource(state, action: PayloadAction<FilesSourceState>) {
            state.filesSource = action.payload;
        },
        setRowsSource(state, action: PayloadAction<RowsSourceState>) {
            state.rowsSource = action.payload;
        },
        resetRowsSource(state) {
            state.rowsSource = null;
            state.showRowsSpinner = false;
        },
        resetFilesSource(state) {
            state.filesSource = null;
            state.showFilesSpinner = false;
        },
        setFileSelection(state, action: PayloadAction<number>) {
            state.selectedFile = action.payload;
        },
        resetFileSelection(state) {
            state.selectedFile = null;
        },
        toggleFilesSpinner(state, action: PayloadAction<boolean>) {
            state.showFilesSpinner = action.payload;
        },
        toggleRowsSpinner(state, action: PayloadAction<boolean>) {
            state.showRowsSpinner = action.payload;
        },
        toggleResultsSpinner(state, action: PayloadAction<boolean>) {
            state.showResultsSpinner = action.payload;
        },
        resetScreen() {
            return { ...initialState };
        },
        resetPagination(state) {
            if (state.rowsSource && state.rowsSource.filter) {
                state.rowsSource = {
                    ...state.rowsSource,
                    filter: {
                        ...state.rowsSource.filter,
                        tokens: [],
                    },
                };
            }
        },
    },
});

export const actions = dashboardComparerSlice.actions;
export default dashboardComparerSlice.reducer;
